$(function(){
	
	$(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({'left_arrow_class':'.icon-left-open','right_arrow_class':'.icon-right-open'});
    });

	$('.utilochaticons').click(function() {
	  openChat();
	});
			
});

/**
 * Chat oeffnen 
 */
function openChat(){
	
	$('#utiloChatModal').modal('show');
	
}
